import { useMutation } from '@northladder/services';

import { INV_MGMT_SERVICE_API } from '../../../InventoryManagementClient';

/**
 * This is to track the mutation key for the fetch signed url from cdn mutation.
 */
const MUT_FETCH_SIGNED_URL_FROM_CDN = 'fetch-Signed-Url-From-Cdn-Mutation';

/**
 * React Query mutation function for fetching signed url from cdn.
 * the pod.
 * TODO: @bobin why are't we using onSuccess & onError
 */
export const useFetchSignedUrlFromCdnMutation = () => {
  const { isPending, isError, error, data, mutate, isSuccess } = useMutation({
    mutationKey: [MUT_FETCH_SIGNED_URL_FROM_CDN],
    networkMode: 'always',
    mutationFn: INV_MGMT_SERVICE_API.getFileFromSignedUrl,
    retry: 1,
  });

  return {
    isSignedUrlError: isError,
    isSignedUrlLoading: isPending,
    isSignedUrlSuccess: isSuccess,
    signedUrlError: error,
    mutateAndGetSignedUrl: mutate,
    signedUrl: data,
  };
};
